import { render } from "./MessageManager.vue?vue&type=template&id=2949cc90"
import script from "./MessageManager.vue?vue&type=script&lang=js"
export * from "./MessageManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__